import { Button } from 'react-bootstrap'

import { numberFormatCurrency } from '../../utils/helpers'
import { formatToLocalTime } from '../../utils/dates'

const ViewMobile = ({ record = {} }, isInvoice = false) => {
  const { total = 0, number, dateCreated, createdBy = {}, client } = record
  return (
    <div className='px-4 text-center'>
      <h4 className='fw-bold '>{isInvoice ? 'Invoice' : 'Estimate'}</h4>

      <Button variant='default' className='text-primary text-uppercase fw-bold p-0' >View PDf</Button>

      <div className='my-3 fs-small'>
        <strong className='d-block'>#{number} · {formatToLocalTime(dateCreated)}</strong>
        <span className='d-block'>Created by: {createdBy.name || '[MTRX User]'}</span>
        <span className='d-block'>for: {client.name || '[Client Name]'}</span>
      </div>

      <div>
        <h1 className='mb-0'>{numberFormatCurrency('usd', total)}</h1>
        <span>{isInvoice ? 'Invoice Total' : 'Estimate Total'}</span>
      </div>
    </div>
  )
}

export default ViewMobile
